import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditableTable from "components/smea/Table/EditableTable";
import { useStateContext } from "contexts/ContextProvider";
import ConfirmationModal from "modals/smea/miscellaneous/ConfirmationModal";
import dayjs from "dayjs";
import useAxiosPrivate from "contexts/interceptors/axios";

export default function DataTable({
  data,
  setSelectedData,
  loadingState,
  updateTableFunction,
}) {
  const { auth } = useStateContext();
  const axiosPrivate = useAxiosPrivate();
  const [selectedResult, setSelectedResult] = useState();
  const [rowToDelete, setRowToDelete] = useState();

  const [open, setOpen] = useState(false);
  const [promptResponse, setPromptResponse] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [submitKind, setSubmitKind] = useState("");
  const [promptDesc, setPromptDesc] = useState("");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (rowToDelete) {
      setPromptDesc("Are you sure you want to delete this data?");
      setSubmitKind("delete");
      setOpen(true);
    }
  }, [rowToDelete]);

  useEffect(() => {
    if (!open && submit && promptResponse && rowToDelete) {
      setLoading(true);

      axiosPrivate
        .delete(`/competency/deleteResult/${rowToDelete[0]?.id}`)
        .then(() => {
          alert("Data deleted successfully");
          setRowToDelete(null);
          setSubmit(false);
          updateTableFunction();
        })
        .catch((err) => {
          alert(err?.message);
          setRowToDelete(null);
          setSubmit(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [submit, promptResponse]);

  let filteredColumn = [
    // { field: "id", headerName: "ID", width: 70 },
    { field: "schoolYear", headerName: "School Year", width: 130 },
    {
      field: "quarter",
      headerName: "Quarter",
      width: 150,
      valueGetter: (params) => {
        if (params.value === 1) {
          return "First Quarter";
        }
        if (params.value === 2) {
          return "Second Quarter";
        }
        if (params.value === 3) {
          return "Third Quarter";
        }
        if (params.value === 4) {
          return "Fourth Quarter";
        }
        return null;
      },
    },
    {
      field: "office",
      headerName: "School/Office",
      width: 200,
      valueGetter: (params) => {
        const office = params.value;

        return office?.officeName;
      },
    },
    {
      field: "subject",
      headerName: "Subject",
      width: 300,
      valueGetter: (params) => {
        const subject = params.value;

        return subject?.name;
      },
    },
    {
      field: "components",
      headerName: "Component",
      width: 150,
      valueGetter: (params) => {
        const component = params.value;

        return component?.name;
      },
    },
    { field: "gradeLevel", headerName: "Grade Level", width: 120 },
    {
      field: "overallAverageMPS",
      headerName: "Average MPS",
      width: 150,
      valueGetter: (params) => {
        const value = parseFloat(params?.value).toFixed(2);
        return value;
      },
    },
    {
      field: "overallAverageSD",
      headerName: "Average SD",
      width: 150,
      valueGetter: (params) => {
        const value = parseFloat(params?.value).toFixed(2);
        return value;
      },
    },
    {
      field: "status",
      headerName: "Submit Type",
      width: 150,
      valueGetter: (params) =>
        // eslint-disable-next-line no-nested-ternary
        params?.value === 1
          ? "Submitted"
          : params?.value === 0
          ? "Saved"
          : "Unknown",
    },
    {
      field: "createdAt",
      headerName: "Date & Time",
      width: 180,
      valueGetter: (params) =>
        dayjs(params?.value).format("MM/DD/YYYY hh:mm:ss A"),
    },
  ];

  setSelectedData(selectedResult);

  if (auth?.role === "teacher" || auth?.role === "school head") {
    filteredColumn = filteredColumn.filter(
      (obj) => obj.field !== "formOfficeName"
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <ConfirmationModal
        open={open}
        handleClose={() => setOpen(false)}
        setPromptResponse={setPromptResponse}
        setSubmit={setSubmit}
        submitKind={submitKind}
        promptDesc={promptDesc}
      />
      <EditableTable
        data={data}
        columns={filteredColumn}
        loading={loading || loadingState}
        rowToDelete={setRowToDelete}
        singleSelect
        setSelectedData={setSelectedResult}
        height="60vh"
        checkbox
        showSearch
        remove
      />
    </Box>
  );
}
